import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api, { getMediaUrl } from '../services/api';
import './Services.css';

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    try {
      const response = await api.get('/services/');
      setServices(response.data);
    } catch (error) {
      console.error('Error loading services:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  return (
    <Container className="services-page py-5">
      <div className="page-header mb-5">
        <h1 className="page-title">Citizen Services</h1>
        <p className="page-subtitle">Explore various services offered by the municipality</p>
      </div>
      
      <Row className="g-4">
        {services.map(service => (
          <Col key={service.id} lg={4} md={6} sm={12}>
            <Card className="service-card h-100 shadow-sm">
              {service.image ? (
                <div className="service-image-wrapper">
                  <Card.Img 
                    variant="top" 
                    src={getMediaUrl(service.image)} 
                    alt={service.name}
                    className="service-image"
                  />
                  {service.icon && (
                    <div className="service-icon-overlay">
                      <i className={`${service.icon} fa-2x text-white`}></i>
                    </div>
                  )}
                </div>
              ) : (
                <div className="service-icon-placeholder">
                  {service.icon ? (
                    <i className={`${service.icon} fa-3x text-primary`}></i>
                  ) : (
                    <i className="fas fa-cogs fa-3x text-primary"></i>
                  )}
                </div>
              )}
              
              <Card.Body>
                <Card.Title className="service-name">
                  <Link to={`/services/${service.slug}`}>{service.name}</Link>
                </Card.Title>
                <Card.Text className="service-description">
                  {service.description.replace(/<[^>]*>/g, '').substring(0, 120)}...
                </Card.Text>
                
                {service.fees && (
                  <p className="service-fee">
                    <small className="text-muted">Fees: </small>
                    <strong className="text-success">{service.fees}</strong>
                  </p>
                )}
                
                <Link to={`/services/${service.slug}`} className="btn btn-primary btn-sm w-100">
                  Learn More <i className="fas fa-arrow-right ms-2"></i>
                </Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {services.length === 0 && (
        <div className="text-center py-5">
          <p className="text-muted">No services available at this time.</p>
        </div>
      )}
    </Container>
  );
};

export default Services;

